var twig = require("twig").twig,
    tokens = [{"type":"raw","value":"<input type=\"checkbox\" (input)>"}],
    template = twig({"id":"$resolved:988eb1e3c49fb128f985f4e1e46228db7cf02b31db1f5e912b62b188d351bcabe9df6db9cb85ec2d86838ca22dea828c71d882d51eadb34ef66427bebe5b82f1:magic-input-checkbox.twig","data":[{"type":"raw","value":"<input type=\"checkbox\" (input)>"}],"allowInlineIncludes":true,"rethrow":true});

module.exports = function(context) { return template.render(context); }

module.exports.tokens = tokens;